// Detect if a PDF is password-protected by checking for '/Encrypt' in the head/tail of the file.
// This is a lightweight heuristic and avoids prompting for passwords.
export const isPdfPasswordProtected = async (file: File): Promise<boolean> => {
  try {
    if (file.type !== 'application/pdf') return false;
    const tailSize = Math.min(8192, file.size);
    const tailBlob = file.slice(file.size - tailSize, file.size);
    const headSize = Math.min(4096, file.size);
    const headBlob = file.slice(0, headSize);
    const readAsText = (blob: Blob) =>
      new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(reader.error);
        reader.onload = () => resolve(new TextDecoder('latin1').decode(new Uint8Array(reader.result as ArrayBuffer)));
        reader.readAsArrayBuffer(blob);
      });
    const [headText, tailText] = await Promise.all([readAsText(headBlob), readAsText(tailBlob)]);
    const haystack = `${headText}\n${tailText}`;
    return haystack.includes('/Encrypt');
  } catch {
    return false;
  }
};
